import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Calculette from "@/pages/Calculette";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Calculette />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
